// Saved reports ("My saved reports" on Live Reporting — step 8 part 2): report_presets rows, one person's own
// (RLS: owner_id = current_staff_id()). options = what the report opened with: { clientIds, years, allYears, filters }.
//
// ⛔ Every write checks the affected-row count: an RLS-refused write returns 0 rows and NO error.
// → { ok: true, data } or { ok: false, error } (a sentence for the screen).
import { supabase } from '../supabase';

const friendly = (e) => (e?.code === '23505' ? 'you already have a saved report with that name' : e?.message || 'it was not saved (no permission?)');

export async function loadPresets(ownerId) {
  if (!ownerId) return { ok: true, data: [] };
  const { data, error } = await supabase.from('report_presets').select('id, name, report_id, options, updated_at')
    .eq('owner_id', ownerId).order('name');
  return error ? { ok: false, error: `Saved reports could not be loaded: ${error.message}` } : { ok: true, data: data || [] };
}

async function checked(q, what) {
  const { data, error } = await q.select('id, name, report_id, options, updated_at');
  if (error || !data?.length) return { ok: false, error: `${what} — ${friendly(error)}` };
  return { ok: true, data: data[0] };
}

export const savePreset = ({ ownerId, name, reportId, options }) =>
  checked(supabase.from('report_presets').insert({ owner_id: ownerId, name: name.trim(), report_id: reportId, options }), `"${name}" not saved`);

export const updatePresetOptions = (id, options) =>
  checked(supabase.from('report_presets').update({ options, updated_at: new Date().toISOString() }).eq('id', id), 'Not updated');

export const renamePreset = (id, name) =>
  checked(supabase.from('report_presets').update({ name: name.trim(), updated_at: new Date().toISOString() }).eq('id', id), 'Not renamed');

export const deletePreset = (id) => checked(supabase.from('report_presets').delete().eq('id', id), 'Not deleted');
